module.exports = __webpack_public_path__ + "img/06-10.c2805bf1.png";